import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { GgcAlert } from '@/components/ui/ggc/alert';

/**
 * One-shot flash notification (e.g. after login).
 * Reads `location.state.flash`, shows it, auto-dismisses after 5s.
 */
export default function FlashMessage() {
  const location = useLocation();
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    const flash = (location.state as { flash?: string })?.flash;
    if (flash) {
      setMessage(flash);
      const timer = setTimeout(() => setMessage(null), 5000);
      return () => clearTimeout(timer);
    }
    setMessage(null);
  }, [location]);

  if (!message) return null;

  return (
    <div className="p-3">
      <GgcAlert tone="success" className="justify-between">
        <span className="flex-1">{message}</span>
        <button
          type="button"
          aria-label="Dismiss"
          className="ml-2 text-current opacity-70 hover:opacity-100"
          onClick={() => setMessage(null)}
        >
          &times;
        </button>
      </GgcAlert>
    </div>
  );
}
